/*
 * File: cell-translation-job-created.ts
 * Created: 2026-01-22
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobCreated extends BaseTableBodyCell {
    get createdText() {
        if (!this.value) return "-";
        const date = new Date(this.value);
        if (Number.isNaN(date.getTime())) return "-";
        return date.toLocaleString();
    }
}
